module.exports = __webpack_public_path__ + "img/cursor-click.213c3281.svg";